import { DropdownItem } from '@/common/components';
import { TFunction } from 'i18next';
import { TypeOfRequestOptionId } from '../../constants/lists/typeOfRequest';
import { HRNSampleStatusOptionId } from '../../constants/lists/sampleStatus';
import { PaperConsentOptionid } from '../../constants/lists/paperConsent';

export const getTypeOfRequestOptions = (t: TFunction): DropdownItem[] => {
  return [
    {
      id: TypeOfRequestOptionId.WITHDRAWAL,
      label: t(`form.request_details.type_of_request_option.${TypeOfRequestOptionId.WITHDRAWAL}`),
    },
    {
      id: TypeOfRequestOptionId.WITHDRAWAL_DELETION,
      label: t(`form.request_details.type_of_request_option.${TypeOfRequestOptionId.WITHDRAWAL_DELETION}`),
    },
  ];
};

export const getHRNSampleStatusOptions = (t: TFunction): DropdownItem[] => {
  return [
    {
      id: HRNSampleStatusOptionId.PRIOR_TO_SAMPLE_COLLECTION,
      label: t(`form.request_details.hrn_sample_status_option.${HRNSampleStatusOptionId.PRIOR_TO_SAMPLE_COLLECTION}`),
    },
    {
      id: HRNSampleStatusOptionId.PRIOR_TO_RESULT_RETURN,
      label: t(`form.request_details.hrn_sample_status_option.${HRNSampleStatusOptionId.PRIOR_TO_RESULT_RETURN}`),
    },
    {
      id: HRNSampleStatusOptionId.AFTER_RESULT_RETURN,
      label: t(`form.request_details.hrn_sample_status_option.${HRNSampleStatusOptionId.AFTER_RESULT_RETURN}`),
    },
  ];
};

export const getPaperConsentOptions = (t: TFunction): DropdownItem[] => {
  return [
    {
      id: PaperConsentOptionid.HHC_ESIGNATURE,
      label: t(`form.request_details.paper_consent_option.${PaperConsentOptionid.HHC_ESIGNATURE}`),
    },
    {
      id: PaperConsentOptionid.PAPER_CONSENT,
      label: t(`form.request_details.paper_consent_option.${PaperConsentOptionid.PAPER_CONSENT}`),
    },
    {
      id: PaperConsentOptionid.PARTNER_HOSTED_CONSENT,
      label: t(`form.request_details.paper_consent_option.${PaperConsentOptionid.PARTNER_HOSTED_CONSENT}`),
    },
  ];
};
